module.exports = "th {\r\n    min-width: 130px;\r\n}\r\n\r\nth.action-col {\r\n    min-width: 132px;\r\n}\r\n\r\n.main {\r\n    padding-bottom: 100px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/expenses/expense-list/expense-list.component.css
// module id = ./src/app/components/expenses/expense-list/expense-list.component.css
// module chunks = main